'use strict';
import React, { PureComponent } from 'react';
import ComboMarca from './ComboMarca';
import ComboTipoCuenta from './ComboTipoCuenta';
import ImporteSinIva from './ImporteSinIva';

class SeccionSuperior extends PureComponent {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        $('[data-toggle="tooltip"]').tooltip();
    }
    componentDidUpdate() {
        $('[data-toggle="tooltip"]').tooltip();
    }

    render() {

        const { abrirModal, selectCombo, selectRadioButton, actualizarImporteSinIVA, actualizarTipoOperacion, obtenerDatosGrilla, borrarFiltros } = this.props.actions;
        const { objFiltradoBtnVer, marca, tipoCuenta, marcaSeleccionada, tipoCuentaSeleccionada, rdButtonAjusteCargo, importeSinIVA, tipoOperacion, movimientosFiltradosParaMostrarPanel } = this.props.data;

        let estado = objFiltradoBtnVer && objFiltradoBtnVer.estado ? objFiltradoBtnVer.estado : "PEND. CONFIRMACIÓN";
        let tipoOperacionCredito = tipoOperacion && tipoOperacion.credito ? true : false;
        let tipoOperacionDebito = tipoOperacion && tipoOperacion.debito ? true : false;

        let datosBtnVer = {
            marca: marcaSeleccionada ? marcaSeleccionada : null,
            tipoCuenta: tipoCuentaSeleccionada ? tipoCuentaSeleccionada : null,
            tipoMovimiento: rdButtonAjusteCargo ? rdButtonAjusteCargo : null,
            estado: objFiltradoBtnVer ? objFiltradoBtnVer : estado,
            importeMin: importeSinIVA && importeSinIVA.min && importeSinIVA.min != "" ? importeSinIVA.min : null,
            importeMax: importeSinIVA && importeSinIVA.max && importeSinIVA.max != "" ? importeSinIVA.max : null,
            tipoOperacion: tipoOperacion ? tipoOperacion : null,
            motivosSeleccionados: movimientosFiltradosParaMostrarPanel ? movimientosFiltradosParaMostrarPanel : null,
            errorMin: importeSinIVA.errorMin,
            errorMax: importeSinIVA.errorMax
        }

        return (
            <div className={"confirmadorAjusteCargoSeccionSuperiorDivPrincipal"}>
                <div className={"confirmadorAjusteCargoSeccionSuperiorTitulo"}>
                    <span>Confirmación masiva de ajustes y cargos</span>
                </div>

                <div className={"confirmadorAjusteCargoTable"}>
                    <div className={"confirmadorAjusteCargoSeccionSuperiorDiv"}>
                        <div>
                            <label className="confirmadorAjusteCargoSeccionSuperiorLblPpal">Marca</label>
                            <div>
                                <ComboMarca marca={marca} selectCombo={selectCombo} marcaSeleccionada={marcaSeleccionada} />
                            </div>
                        </div>
                        <div className={"confirmadorAjusteCargoSeccionSuperiorDivMarginTopTipoCuenta"}>
                            <label className="confirmadorAjusteCargoSeccionSuperiorLblPpal">Tipo de cuenta</label>
                            <div>
                                <ComboTipoCuenta tipoCuenta={tipoCuenta} selectCombo={selectCombo} tipoCuentaSeleccionada={tipoCuentaSeleccionada} />
                            </div>
                        </div>
                    </div>

                    <div className={"confirmadorAjusteCargoSeccionSuperiorLinea"}></div>

                    <div className={"confirmadorAjusteCargoSeccionSuperiorDiv confirmadorAjusteCargoSeccionSuperiorPaddingLeft"}>
                        <div>
                            <label className="confirmadorAjusteCargoSeccionSuperiorLblPpal">Tipo de movimiento</label>
                            <div>
                                <input id={"ajuste"} type="radio" name="ajuste" onChange={(e) => selectRadioButton("A")} value={"A"} checked={rdButtonAjusteCargo == 'A'} />
                                <label className="confirmadorAjusteCargoSeccionSuperiorLblRadio label-secondary" htmlFor={"ajuste"}>Ajuste</label>

                                <input id={"cargo"} type="radio" name="cargo" className={"confirmadorAjusteCargoSeccionSuperiorCargoRadio"} onChange={(e) => selectRadioButton("C")} value={"C"} checked={rdButtonAjusteCargo == 'C'} />
                                <label className="confirmadorAjusteCargoSeccionSuperiorLblRadio label-secondary" htmlFor={"cargo"}>Cargo</label>
                            </div>
                        </div>
                        <div className={"confirmadorAjusteCargoSeccionSuperiorDivMarginTop confirmadorAjusteCargoSeccionSuperiorDivEstado"}>
                            <label className="confirmadorAjusteCargoSeccionSuperiorLblPpal">Estado</label>
                            <div>
                                <div className={"confirmadorAjusteCargoSeccionSuperiorEstado"}>{estado}</div>
                                <div>
                                    <a className="clickable none-text-decoration confirmadorAjusteCargoSeccionSuperiorEdicion" aria-hidden="true" onClick={() => abrirModal(true, 1)}></a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={"confirmadorAjusteCargoSeccionSuperiorLinea"}></div>

                    <ImporteSinIva errorMin={importeSinIVA.errorMin} errorMax={importeSinIVA.errorMax} min={importeSinIVA.min} max={importeSinIVA.max} actualizarImporteSinIVA={actualizarImporteSinIVA} />

                    <div className={"confirmadorAjusteCargoSeccionSuperiorLinea"}></div>

                    <div className="confirmadorAjusteCargoSeccionSuperiorDivDerecha">
                        <div>
                            <label className="confirmadorAjusteCargoSeccionSuperiorLblPpal">Tipo de operación</label>
                            <div>
                                <input type="checkbox" checked={tipoOperacionCredito} onChange={(e) => actualizarTipoOperacion("credito", !tipoOperacionCredito)} className={"default-checkbox checkProcesosSmall"} />
                                <label htmlFor="Credito" className={"confirmadorAjusteCargoSeccionSuperiorLblDebCred"}>Crédito</label>

                                <input type="checkbox" checked={tipoOperacionDebito} onChange={(e) => actualizarTipoOperacion("debito", !tipoOperacionDebito)} className={"default-checkbox checkProcesosSmall confirmadorAjusteCargoSeccionSuperiorMarginLeftChk"} />
                                <label htmlFor="Debito" className={"confirmadorAjusteCargoSeccionSuperiorLblDebCred"}>Débito</label>

                                <button className="confirmadorAjusteCargoSeccionSuperiorBorrarFiltro left-separator-xs" data-toggle="tooltip" key={"limpiarFiltroBtn"} data-title={"Limpiar filtros"} data-placement="top" onClick={() => borrarFiltros()}></button>

                                <button className={"btn btn-cta confirmadorAjusteCargoSeccionSuperiorBtnVer"} onClick={() => obtenerDatosGrilla(datosBtnVer)}>Ver</button>
                            </div>
                        </div>
                        <div className={"confirmadorAjusteCargoSeccionSuperiorMarginTopMotivoAjuste"}>
                            <label className="confirmadorAjusteCargoSeccionSuperiorLblPpal">{rdButtonAjusteCargo == 'A' ? "Motivo de ajuste" : "Concepto de Cargo"}</label>
                            <div>
                                <a className="clickable confirmadorAjusteCargoSeccionSuperiorMotivoAjuste" aria-hidden="true" onClick={() => abrirModal(true, 2)}>Seleccionar...</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SeccionSuperior;